import { intlShape } from 'react-intl';
import { getLocalizedData } from '@braindate/domain/lib/base/l10n/util';

export function getFieldTitle(
  { body, label_intl: labelIntl }: Field,
  intl: intlShape,
) {
  if (labelIntl) {
    return intl.formatMessage(labelIntl);
  }
  return getLocalizedData(body).label;
}
